import { createGlobalStyle } from 'styled-components'

import { down } from '@Globals/Style/breakpoints'
import { box } from '@Globals/Style/mixins'

const GlobalStyle = createGlobalStyle`
  /* Own resets */
  * {
    padding: 0;
    margin: 0;
    outline: 0;
  }

  html {
    font-size: 15px;
    text-size-adjust: 100%;

    *, *::after, *::before {
      line-height: ${({ theme }) => theme.typography.lineHeight};
      color: ${({ theme }) => theme.typography.baseFontColor};
      box-sizing: border-box;
      font-weight: 400;
      -webkit-tap-highlight-color: rgba(0,0,0,0);
    }
  }

  html[dir="rtl"] {
    font-size: ${({ theme }) => theme.typography.baseFontSizeRtl};
  }

  body {
    text-align: left;
    text-align: initial;
    background-color: #fff;
    width: 100%;
    min-height: 100vh;
    overflow-y: scroll;

    *, *::after, *::before {
      font-family: ${({ theme }) => theme.typography.fontFamily}
    }
  }

  p {
    padding: 0 0 10px 0;
    margin: 0;
  }

  a {
    text-decoration: none;
    background-color: transparent;

    &:active,
    &:hover {
      outline: 0;
    }
  }

  b, strong {
    font-weight: bold;
  }

  h1 {
    margin: 0;
    padding: 0 0 10px 0;
    font-size: 2rem;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
    ${down('phablet')} {
      font-size: 1.75rem;
      line-height: 1.2;
    }
  }

  h2 {
    margin: 0;
    padding: 0 0 10px 0;
    font-size: 1.25rem;
    font-weight: normal;
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }

  h3 {
    margin: 0;
    padding: 0;
    font-size: 1rem;
    font-weight: normal;
    text-transform: uppercase;
  }

  h4, h5, h6 {
    font-weight: normal;
  }

  form {
    display: block;
  }

  img {
    display: block;
    width: 100%;
    height: initial;
    height: auto;
    border: 0;
  }

  svg {
    ${box({ width: '100%' })}
  }

  ul {
    list-style: none;
  }

  /* Other resets found online */
  body,
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  main,
  menu,
  nav,
  section,
  summary {
    display: block;
  }

  abbr[title] {
    border-bottom: none;
    text-decoration: underline;
    text-decoration: underline dotted;
  }

  svg:not(:root) {
    overflow: hidden;
  }

  pre {
    overflow: auto;
  }

  code, kbd, pre, samp {
    font-family: monospace;
    font-size: 1rem;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    display: block;
    font: inherit;
    margin: 0;
  }

  button {
    overflow: visible;
    border-radius: 0;
  }

  button, select {
    text-transform: none;
  }

  button,
  html input[type="button"],
  input[type="reset"],
  input[type="submit"] {
    appearance: button;
    cursor: pointer;
  }

  button[disabled],
  html input[disabled] {
    cursor: default;
  }

  input {
    line-height: normal;
  }

  button::-moz-focus-inner,
  input::-moz-focus-inner {
    border: 0;
    padding: 0;
  }

  button:-moz-focusring,
  input:-moz-focusring {
    outline: 1px dotted ButtonText;
  }

  input[type="checkbox"],
  input[type="radio"] {
    box-sizing: border-box;
    padding: 0;
  }

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    height: auto;
  }

  input[type="search"] {
    appearance: textfield;
  }

  input[type="search"]::-webkit-search-cancel-button,
  input[type="search"]::-webkit-search-decoration {
    appearance: none;
  }

  legend {
    border: 0;
    padding: 0;
  }

  textarea {
    overflow: auto;
  }

  optgroup {
    font-weight: bold;
  }
`

export default GlobalStyle
